import { AppBar, Box, Toolbar, IconButton, Typography, useTheme } from '@mui/material'
import {
  Brightness7 as Brightness7Icon,
  Brightness4 as Brightness4Icon,
} from '@mui/icons-material'
import LanguagePicker from './LanguagePicker'
import AppMenu from './AppMenu'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppContext } from '../contexts/appContext '
import UserMenu from './UserMenu'

interface AppHeaderProps {
  hasAlertBanner?: boolean
}

const Layout = ({ hasAlertBanner }: AppHeaderProps) => {
  const theme = useTheme()
  const colorMode = useContext(AppContext)
  const navigate = useNavigate()

  return (
    <AppBar
      position="sticky"
      color="secondary"
      enableColorOnDark
      elevation={0}
      sx={(theme) => ({
        top: hasAlertBanner ? 48 : 0,
        mb: 0,
        boxShadow: `inset 0 -2px 0 0 ${theme.palette.primary.main}`,
      })}
    >
        <Toolbar sx={{ px: 3 }}>
          <Box
            onClick={() => navigate('/')}
            sx={{ cursor: 'pointer', display: 'flex', alignItems: 'baseline', mr: 2 }}
          >
            <Typography
              component="span"
              sx={{
                fontFamily: '"Quicksand", "Inter", sans-serif',
                fontWeight: 800,
                fontSize: '1.35rem',
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                color: 'inherit',
              }}
            >
              Dev
              <Box component="span" sx={{ color: 'primary.main' }}>Hub</Box>
            </Typography>
          </Box>
          <span style={{ flexGrow: 1 }}>&nbsp;</span>
          <AppMenu />
          <UserMenu />
          <LanguagePicker />
          <IconButton onClick={colorMode.toggleColorMode} sx={{ color: 'inherit' }}>
            {theme.palette.mode === 'dark' ? (
              <Brightness7Icon />
            ) : (
              <Brightness4Icon />
            )}
          </IconButton>
        </Toolbar>
    </AppBar>
  )
}
Layout.default = {
  hasAlertBanner: false,
}
export default Layout
